export default __webpack_public_path__ + "static/media/mockupImg.e36de4e6.png";